import React, { useState, useRef } from 'react';
import { FaRegImage } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import { fileDropZoneStyles, fileDropZoneTextStyles } from '../../styles/commonStyles';
import Spinner from '../Spinner';

/**
 * Компонент для загрузки файлов через drag-and-drop или клик
 * @param {Object} props - Свойства компонента
 * @param {Function} props.onFileSelect - Функция, вызываемая при выборе файла
 * @param {Array} props.allowedFormats - Массив допустимых форматов файлов
 * @param {boolean} props.isUploading - Флаг, указывающий на процесс загрузки
 * @returns {JSX.Element} Компонент зоны загрузки файлов
 */
const FileDropZone = React.forwardRef(({ onFileSelect, allowedFormats, isUploading }, ref) => {
  const { t } = useTranslation();
  const [isDragOver, setIsDragOver] = useState(false);
  const fileInputRef = useRef(null);

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragOver(false);
    const file = e.dataTransfer.files[0];
    if (file) {
      onFileSelect(file);
    }
  };

  const handleFileInputChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      onFileSelect(file);
    }
  };

  return (
    <div className="flex justify-center my-5" ref={ref}>
      {!isUploading ? (
        <div
          className={fileDropZoneStyles(isDragOver)}
          onClick={() => fileInputRef.current.click()}
          onDragOver={(e) => { e.preventDefault(); setIsDragOver(true); }}
          onDragLeave={(e) => { e.preventDefault(); setIsDragOver(false); }}
          onDrop={handleDrop}
        >
          <input
            ref={fileInputRef}
            type="file"
            accept={allowedFormats.map(format => `.${format}`).join(', ')}
            onChange={handleFileInputChange}
            style={{ display: 'none' }}
            id="fileInput"
          />
          <span className={fileDropZoneTextStyles}>
            <FaRegImage size={64} className="mx-auto mb-2 opacity-50" />
            {t('addPostcardModal.dragAndDrop')}
          </span>
        </div>
      ) : (
        <div className="flex justify-center my-4">
          <Spinner />
        </div>
      )}
    </div>
  );
});

export default FileDropZone; 